import { jsx as s } from "react/jsx-runtime";
import { g as i } from "./getAccessibleIconProps-DwOSrVuG.mjs";
const l = ({
  className: t,
  children: e,
  color: n,
  size: o = "1.5rem",
  id: c,
  style: r,
  ...a
}) => /* @__PURE__ */ s(
  "svg",
  {
    className: t,
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    color: n,
    id: c,
    style: r,
    ...a,
    children: e
  }
), h = l, p = ({
  className: t,
  children: e,
  size: n = "16rem",
  id: o,
  style: c,
  ...r
}) => /* @__PURE__ */ s(
  "svg",
  {
    className: t,
    width: n,
    height: n,
    viewBox: "0 0 256 256",
    fill: "none",
    id: o,
    style: c,
    ...r,
    children: e
  }
), m = ({
  className: t,
  children: e,
  size: n = "8rem",
  id: o,
  style: c,
  viewBox: r = "0 0 128 128",
  ...a
}) => /* @__PURE__ */ s(
  "svg",
  {
    className: t,
    width: n,
    height: n,
    viewBox: r,
    overflow: "visible",
    fill: "none",
    id: o,
    style: c,
    ...a,
    children: e
  }
), v = (t, e) => {
  const n = (o) => {
    const c = i(o);
    return /* @__PURE__ */ s(l, { ...c, children: t });
  };
  return n.displayName = e, n;
}, d = (t, e) => {
  const n = (o) => {
    const c = i(o);
    return /* @__PURE__ */ s(p, { ...c, children: t });
  };
  return n.displayName = e, n;
}, g = (t, e, n) => {
  const o = (c) => {
    const r = i(c);
    return /* @__PURE__ */ s(m, { viewBox: n, ...r, children: t });
  };
  return o.displayName = e, o;
};
function f(t, e) {
  const n = (o) => {
    const c = i(o);
    return /* @__PURE__ */ s(t, { ...c });
  };
  return n.displayName = e, n.alias = !0, n;
}
export {
  l as F,
  h as S,
  v as a,
  f as b,
  d as c,
  g as d
};
//# sourceMappingURL=createIcon-DfCe6o-T.mjs.map
